import { NgOptimizedImage } from "@angular/common";
import { Component, EventEmitter, Input, Output } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatMenuModule } from "@angular/material/menu";
import { MatSelectModule } from "@angular/material/select";
import { MatToolbarModule } from "@angular/material/toolbar";
import { Router, RouterModule } from "@angular/router";
import { LocalStorageService } from "src/app/shared/services/local-storage.service";
import { IUserDetails } from "../../../modules/authentication/_interfaces/user.interface";

@Component({
    selector: "app-header",
    standalone: true,
    imports: [
        MatFormFieldModule,
        MatSelectModule,
        MatMenuModule,
        MatIconModule,
        MatButtonModule,
        MatToolbarModule,
        RouterModule,
        NgOptimizedImage,
    ],
    templateUrl: "./site-header.component.html",
    styleUrls: ["./site-header.component.scss"],
})
export class SiteHeaderComponent {
    @Input() userDetails?: IUserDetails;
    @Output() toggleDrawer = new EventEmitter<void>();

    isLoggedIn = this.localStorageService.isLoggedIn();

    constructor(
        private localStorageService: LocalStorageService,
        private router: Router,
    ) {}

    getRouteCssClass(route: string): string {
        return this.router.url.includes(route) ? "link-focus" : "";
    }

    onLogout(): void {
        this.localStorageService.clearLocalStorage();
        this.router.navigateByUrl("authentication");
    }

    onLogo(): void {
        if (this.isLoggedIn) {
            this.router.navigate(["/"]);
        } else {
            this.router.navigate(["/authentication/login"]);
        }
    }

    onMenu(): void {
        this.toggleDrawer.emit();
    }
}
